import DateRangeFields from '../shared/ui/DateRangeFields'
import { isInvalidDateRange } from '../shared/lib/time'
import { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'

const typeLabels = {
    js: { label: 'JS', bg: '#FEF3C7', color: '#92400E' },
    fetch: { label: 'Fetch', bg: '#EDE9FE', color: '#5B21B6' },
    react: { label: 'React', bg: '#FEE2E2', color: '#991B1B' },
}

export default function Admin() {
    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(true)
    const [selected, setSelected] = useState(null)
    const [filterType, setFilterType] = useState('')
    const [filterFrom, setFilterFrom] = useState('')
    const [filterTo, setFilterTo] = useState('')
    const { token, logout, user } = useAuth()

    const loadErrors = () => {
        if (isInvalidDateRange(filterFrom, filterTo)) return
        setLoading(true)
        const params = new URLSearchParams()
        if (filterType) params.append('type', filterType)
        if (filterFrom) params.append('from', filterFrom)
        if (filterTo) params.append('to', filterTo)
        params.append('limit', '200')

        if (token) {
            fetch(`/api/logs/errors?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(r => r.json())
                .then(d => { setErrors(d); setLoading(false) })
        } else {
            setLoading(false);
        }
    }

    useEffect(() => { loadErrors() }, [token])

    const formatDate = (ts) => {
        if (!ts) return '—'
        const d = new Date(ts)
        return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow' }) +
            ' · ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' })
    }

    const ThStyle = (right = false) => ({
        padding: '10px 14px',
        textAlign: right ? 'right' : 'left',
        fontSize: '11px',
        fontWeight: '600',
        color: '#6B7280',
        background: '#F9FAFB',
        borderBottom: '0.5px solid #E5E7EB',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
    })

    const TdStyle = (right = false) => ({
        padding: '10px 14px',
        fontSize: '12px',
        textAlign: right ? 'right' : 'left',
        borderBottom: '0.5px solid #E5E7EB',
        color: '#374151',
    })

    return (
        <div style={{ minHeight: '100vh', background: '#F2F4F7' }}>

            {selected && (
                <div onClick={() => setSelected(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '600px', maxHeight: '80vh', overflow: 'auto', padding: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1A1A1A' }}>Детали ошибки</h2>
                            <button onClick={() => setSelected(null)} style={{ background: '#F3F4F6', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '18px', cursor: 'pointer' }}>×</button>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {[
                                { label: 'Время', value: formatDate(selected.created_at) },
                                { label: 'Тип', value: selected.type },
                                { label: 'Пользователь', value: selected.user_name ? `${selected.user_name} (${selected.login} · ${selected.user_role})` : '—' },
                                { label: 'IP', value: selected.ip || '—' },
                                { label: 'URL', value: selected.url || '—' },
                                { label: 'Устройство', value: selected.user_agent || '—' },
                            ].map(item => (
                                <div key={item.label}>
                                    <div style={{ fontSize: '11px', color: '#9CA3AF', marginBottom: '2px' }}>{item.label}</div>
                                    <div style={{ fontSize: '13px', color: '#1A1A1A', wordBreak: 'break-all' }}>{item.value}</div>
                                </div>
                            ))}
                            <div>
                                <div style={{ fontSize: '11px', color: '#9CA3AF', marginBottom: '4px' }}>Сообщение</div>
                                <div style={{ background: '#FEF2F2', borderRadius: '8px', padding: '10px 12px', fontSize: '12px', color: '#DC2626', fontFamily: 'monospace', wordBreak: 'break-all' }}>{selected.message}</div>
                            </div>
                            {selected.stack && (
                                <div>
                                    <div style={{ fontSize: '11px', color: '#9CA3AF', marginBottom: '4px' }}>Stack trace</div>
                                    <div style={{ background: '#F9FAFB', borderRadius: '8px', padding: '10px 12px', fontSize: '11px', color: '#374151', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: '200px', overflow: 'auto' }}>{selected.stack}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div style={{ background: 'white', borderBottom: '1px solid #E5E7EB', padding: '10px 16px', position: 'sticky', top: 0, zIndex: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <img src="/logo.png" alt="CoFresh" style={{ height: '22px', filter: 'invert(1)' }} />
                    <button onClick={logout} style={{ fontSize: '13px', color: '#DC2626', background: '#FEF2F2', border: 'none', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontWeight: '500' }}>Выйти</button>
                </div>
                <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#6B7280' }}>{user?.last_name} {user?.first_name} · Администратор</p>
            </div>

            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

                <div style={{ background: 'white', borderRadius: '12px', padding: '16px', border: '0.5px solid #E5E7EB' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#1A1A1A' }}>
                            Лог ошибок <span style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: '400' }}>({errors.length})</span>
                        </p>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                            <select value={filterType} onChange={e => setFilterType(e.target.value)} style={{ fontSize: '12px', padding: '6px 10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', outline: 'none' }}>
                                <option value="">Все типы</option>
                                <option value="js">JS</option>
                                <option value="fetch">Fetch</option>
                                <option value="react">React</option>
                            </select>
                            <DateRangeFields from={filterFrom} to={filterTo} onFromChange={setFilterFrom} onToChange={setFilterTo} />
                            <button onClick={loadErrors} style={{ padding: '6px 14px', background: '#0052FF', color: 'white', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>Найти</button>
                        </div>
                    </div>

                    {loading ? (
                        <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '30px 0' }}>Загрузка...</p>
                    ) : errors.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '30px 0' }}>Ошибок не найдено</p>
                    ) : (
                        <div style={{ borderRadius: '8px', overflow: 'hidden', border: '0.5px solid #E5E7EB' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...ThStyle(), width: '13%' }}>Время</th>
                                        <th style={{ ...ThStyle(), width: '7%' }}>Тип</th>
                                        <th style={{ ...ThStyle(), width: '13%' }}>Пользователь</th>
                                        <th style={{ ...ThStyle(), width: '35%' }}>Сообщение</th>
                                        <th style={{ ...ThStyle(), width: '10%' }}>IP</th>
                                        <th style={{ ...ThStyle(), width: '22%' }}>Устройство</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {errors.map((e, i) => {
                                        const typeInfo = typeLabels[e.type] || { label: e.type, bg: '#F3F4F6', color: '#6B7280' }
                                        return (
                                            <tr key={e.id}
                                                onClick={() => setSelected(e)}
                                                style={{ background: i % 2 === 0 ? 'white' : '#F9FAFB', cursor: 'pointer' }}
                                                onMouseEnter={ev => ev.currentTarget.style.background = '#EFF6FF'}
                                                onMouseLeave={ev => ev.currentTarget.style.background = i % 2 === 0 ? 'white' : '#F9FAFB'}
                                            >
                                                <td style={{ ...TdStyle(), color: '#9CA3AF', whiteSpace: 'nowrap' }}>{formatDate(e.created_at)}</td>
                                                <td style={TdStyle()}>
                                                    <span style={{ background: typeInfo.bg, color: typeInfo.color, padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{typeInfo.label}</span>
                                                </td>
                                                <td style={{ ...TdStyle(), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.user_name || '—'}</td>
                                                <td style={{ ...TdStyle(), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#DC2626' }}>{e.message}</td>
                                                <td style={{ ...TdStyle(), whiteSpace: 'nowrap' }}>{e.ip || '—'}</td>
                                                <td style={{ ...TdStyle(), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#9CA3AF' }}>{e.user_agent || '—'}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
